import { React, useState, useEffect } from "react";
import store from "../../../store";
import { Link } from "react-router-dom";
import classes from './Welcome.module.scss'

//MUI imports
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';


function WelcomeScreen({ schema, project }) {

  const [screenContent, setScreenContent] = useState(null);

  function getIntroPoints(){
    if(screenContent){
      let markup = screenContent.items.map((item, index) =>{
        return (
          <Accordion key={index} className={`${classes.Welcome__accordion}`} defaultExpanded={(index === 0 ? true : false)}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <div className={`${classes.Welcome__accordion__summary}`}><p dangerouslySetInnerHTML={{__html:item.title}}></p></div>
            </AccordionSummary>
            <AccordionDetails>
            {item.body.map((content, index) =>{
                return <div className={`${classes.Welcome__accordion__description}`} key={index}>
                  {
                  (
                    content.subtitle ? 
                      <div  className={`${classes.Welcome__accordion__description_subtitle} ${classes.Welcome__accordion__description}`} dangerouslySetInnerHTML={{__html:content.subtitle}}></div>
                      :
                      ""
                  )
                  }
                  <div  className={`${classes.Welcome__accordion__description_copy}  small_copy`} dangerouslySetInnerHTML={{__html:content.copy}}></div>
                </div>
              })}
            </AccordionDetails>
          </Accordion>
        )
      })
      return markup
    }
    return ""
  }

  useEffect(() => {
    if(schema)
      setScreenContent(schema.screenContent.welcome)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schema])

  return (
    <>
        {
          (
            screenContent ? 
            <>
              <Box className="content_wrapper content_wrapper__white"
                sx={{
                  textAlign: "left"
                }}
              >
                <Box className="content_wrapper__inner">
                  <Box className="content_header">
                    <h2 className="content_header__content" dangerouslySetInnerHTML={{__html:screenContent.title}}></h2>
                  </Box>
                  <section>
                      <p className="small_copy small_copy__welcome" dangerouslySetInnerHTML={{__html:screenContent.prerequisites}}></p>
                  </section> 
                  <section className={`${classes.Welcome__accordion_container}`}>
                    {getIntroPoints()}
                  </section>
                  <Link className={"inline_button inline_button__large"} to={`${process.env.PUBLIC_URL}/project/${project.projectId}/${store.getState().pages.assessmentId.slug}`}>
                    <Button variant="contained">Get started</Button>
                  </Link>
                </Box>
              </Box>
            </>
            :
            ""
         )
        }
    </>
  );
}
export default WelcomeScreen